<script setup lang="ts">
import {
  mdiAlphaWBox,
  mdiAlphaCBoxOutline,
  mdiPackageVariantClosed,
  mdiCardMultipleOutline,
} from '@mdi/js'
import { MotionItemType } from '@/api/models/definitions'
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'

interface Props {
  type?: string
  selected?: boolean
}

defineProps<Props>()

const getIconType = (type: string | undefined): string => {
  switch (type) {
    case MotionItemType.Shipment:
      return mdiPackageVariantClosed
    case MotionItemType.WarehouseOrder:
      return mdiAlphaWBox
    case MotionItemType.CustomerOrder:
      return mdiAlphaCBoxOutline
    case MotionItemType.ShipmentGroup:
      return mdiCardMultipleOutline
    default:
      return mdiPackageVariantClosed
  }
}
</script>

<template>
  <div
    class="transition-opacity ease-in duration-300"
    :class="[type ? 'opacity-100' : 'opacity-0']"
  >
    <SvgIcon
      class="h-4 w-4"
      :class="selected ? 'fill-white' : 'fill-gray-700'"
      :path="getIconType(type)"
    />
  </div>
</template>
